export default {
  title: 'لیست محصولات',
  search:'جستجو ...',
  id: 'شناسه',
  name_fa : 'نام فارسی',
  name_en: 'نام لاتین',
  price_irr: 'قیمت ریال',
  price_usd: 'قیمت دلار',
  stock_total: 'کل موجودی',
  stock_reserved: 'موجودی رزروی',
  stock_visible: 'موجودی نمایشی',
  status: 'وضعیت',
  statusActive: 'فعال',
  statusInActive: 'غیرفعال',
  loading:'در حال دریافت اطلاعات ...',
  operating:'عملیات',
  empty:'داده ای یافت نشد',
  success:'موفق',
  next: 'بعدی',
  previous: 'قبلی',
  deleteConfirm:'آیا از حذف این محصول مطمئن هستید؟'




}
